export const ACHIEVEMENT_CATALOG = [
  // Task achievements (Phase 2a)
  { id: 'task_complete_1', title: '✅ First Task Complete', category: 'task', tier: 'bronze', target: 1, active: true },
  { id: 'task_complete_10', title: '📌 10 Tasks Complete', category: 'task', tier: 'silver', target: 10, active: true },
  { id: 'task_complete_50', title: '🏆 50 Tasks Complete', category: 'task', tier: 'gold', target: 50, active: true },

  // Workout achievements (Phase 2a)
  { id: 'workout_log_1', title: '💪 First Workout Logged', category: 'workout', tier: 'bronze', target: 1, active: true },
  { id: 'workout_log_10', title: '🔥 10 Workouts Logged', category: 'workout', tier: 'silver', target: 10, active: true },
  { id: 'workout_log_30', title: '🦾 30 Workouts Logged', category: 'workout', tier: 'gold', target: 30, active: true },

  // Level achievements (Phase 2a)
  { id: 'level_reach_5', title: '🌱 Reached Level 5', category: 'level', tier: 'bronze', target: 5, active: true },
  { id: 'level_reach_10', title: '⭐ Reached Level 10', category: 'level', tier: 'silver', target: 10, active: true },
  { id: 'level_reach_25', title: '👑 Reached Level 25', category: 'level', tier: 'gold', target: 25, active: true },

  // Phase 2b placeholders (inactive)
  { id: 'streak_7', title: '🔥 7-Day Streak', category: 'streak', tier: 'silver', target: 7, active: false },
  { id: 'fit_10k_steps', title: '🚀 10k Steps Champion', category: 'fit', tier: 'silver', target: 1, active: false },
];

export const getAchievementById = (id) => ACHIEVEMENT_CATALOG.find((item) => item.id === id) || null;
